<template>
  <div class="absolute -top-2 left-158 z-10 w-20 h-12.5">
    <div class="z-11 absolute top-0 left-0 w-20 h-10 rounded-md bg-[#d4dff6]" :style="styles" />
    <div class="z-10 absolute top-2.5 left-0 w-20 h-10 rounded-md bg-white" />
  </div>
</template>

<script setup lang="ts">
  import { CSSProperties } from 'vue'

  withDefaults(
    defineProps<{
      styles?: CSSProperties
    }>(),
    {
      styles: () => ({
        boxShadow: '0px 9px 9px -7px #00FFD1',
      }),
    },
  )
</script>

<style scoped></style>
